<img *ngIf="!isTestBankConnector" [src]="selectedBank.logo" alt="selected bank logo" class="w-78px">
<img *ngIf="isTestBankConnector" src="/assets/images/test_bank_connector.png" alt="test bank connector logo"
  class="w-78px">

<h1 class="my-8 font-20 font-md-24">{{ 'common_login_bank' | translate }}</h1>

<p class="text-center mt-1 mb-8 font-14 font-md-15">
  {{ 'common_login_subTitle' | translate }}
  <br class="d-none d-md-inline" />
  {{ 'common_login_subTitle2' | translate }}
</p>

<div class="content bg-dimwhite py-8 mb-15">
  <h3 class="text-dark m-0 pb-5 font-16 font-md-20">{{ 'sca_confirm' | translate }}</h3>
  <div>
    <span class="loaderWrapper">

      <div class="lds-default">
        <div>
          <span></span>
        </div>
        <div>
          <span></span>
        </div>
        <div>
          <span></span>
        </div>
        <div>
          <span></span>
        </div>
        <div>
          <span></span>
        </div>
        <div>
          <span></span>
        </div>
        <div>
          <span></span>
        </div>
        <div>
          <span></span>
        </div>
      </div>
      <img src="/assets/images/svg/phone-shape.svg" alt="smartphone icon">
    </span>
    <span class="font-15 font-md-16">
      {{ 'sca_informations1' | translate }}
      <br class="d-none d-md-inline" />
      {{ 'sca_informations2' | translate }}
    </span>
  </div>
</div>

<div class="d-flex justify-center">
  <button (click)="goBack()" class="btn bg-gray rounded-full px-5" type="button">
    <span class="picto-puce-right d-none d-md-inline"></span>
    {{ 'common_return' | translate }}
  </button>
</div>